const APISetudata = [
  {
    id: 1,
    api: "Class XII Passing Certificate",
    link: "https://apisetu.gov.in/directory/api/dhsekerala/dhsekerala",
    details:
      "Board of Higher Secondary Examinations, Directorate of General Education, Government of Kerala has made available HSE Certificate cum Marklist of MARCH 2020, which can be pulled by students into their Digilocker account",
  },
  {
    id: 2,
    api: "Degree/ Diploma Certificate",
    link: "https://apisetu.gov.in/directory/api/ktuapp/ktuapp",
    details:
      "APJ Abdul Kalam Technological University (initially Kerala Technological University),a State Government University established by the government of Kerala (https://ktu.edu.in) is issuing Degree certificates for the year 2021 through Digilocker. These can be pulled by the students into their digilocker account.",
  },
  {
    id: 3,
    api: "Indian Navy Certificate",
    link: "https://apisetu.gov.in/directory/api/aswschool/aswschool",
    details:
      "Anti Submarine Warfare School is issuing their Digital awards for the following years, through DigiLocker. These can be pulled by students into their DigiLocker accounts. Degree - 2018,2019,2020,2021,2022 Marksheet - 2017,2019,2020,2021,2022 Diploma - NA Transcript - NA",
  },
  {
    id: 4,
    api: "Ration Card",
    link: "https://apisetu.gov.in/directory/api/civilsupplieskerala/civilsupplieskerala",
    details:
      "Ration Cards issued by The Department of Civil Supplies functions under the Department of Food, Civil Supplies and Consumer Affairs of the Government of Kerala. (https://civilsupplieskerala.gov.in/) are available for download on DigiLocker.",
  },
  {
    id: 5,
    api: "Vocational Higher Secondary",
    link: "https://apisetu.gov.in/directory/api/vhseker/vhseker",
    details:
      "Board of Vocational Higher Secondary Examinations, Directorate of General Education, Government of Kerala has made available VHSE Marklist of MARCH 2020, which can be pulled by students into their Digilocker accounts",
  },
  {
    id: 6,
    api: "Caste Certificate",
    link: "https://apisetu.gov.in/directory/api/edistrictkerala/edistrictkerala",
    details:
      "eDistrict Kerala (https://edistrict.kerala.gov.in/) is the online service delivery portal for Kerala State Govt. Certain documents issued by it (e.g. Residence, Income, Caste Certificates etc) are made available in citizens' DigiLocker accounts.",
  },
  {
    id: 7,
    api: "Community Certificate",
    link: "https://apisetu.gov.in/directory/api/edistrictkerala/edistrictkerala",
    details:
      "eDistrict Kerala (https://edistrict.kerala.gov.in/) is the online service delivery portal for Kerala State Govt. Certain documents issued by it (e.g. Residence, Income, Caste Certificates etc) are made available in citizens' DigiLocker accounts.",
  },
  {
    id: 8,
    api: "Conversion Certificate",
    link: "https://apisetu.gov.in/directory/api/edistrictkerala/edistrictkerala",
    details:
      "eDistrict Kerala (https://edistrict.kerala.gov.in/) is the online service delivery portal for Kerala State Govt. Certain documents issued by it (e.g. Residence, Income, Caste Certificates etc) are made available in citizens' DigiLocker accounts",
  },
  {
    id: 9,
    api: "Identification Certificate",
    link: "https://apisetu.gov.in/directory/api/edistrictkerala/edistrictkerala",
    details:
      "eDistrict Kerala (https://edistrict.kerala.gov.in/) is the online service delivery portal for Kerala State Govt. Certain documents issued by it (e.g. Residence, Income, Caste Certificates etc) are made available in citizens' DigiLocker accounts.",
  },
  {
    id: 10,
    api: "Income Certificate",
    link: "https://apisetu.gov.in/directory/api/edistrictkerala/edistrictkerala",
    details:
      "eDistrict Kerala (https://edistrict.kerala.gov.in/) is the online service delivery portal for Kerala State Govt. Certain documents issued by it (e.g. Residence, Income, Caste Certificates etc) are made available in citizens' DigiLocker accounts.",
  },
  {
    id: 11,
    api: "Inter-Caste Marriage Certificate",
    link: "https://apisetu.gov.in/directory/api/edistrictkerala/edistrictkerala",
    details:
      "eDistrict Kerala (https://edistrict.kerala.gov.in/) is the online service delivery portal for Kerala State Govt. Certain documents issued by it (e.g. Residence, Income, Caste Certificates etc) are made available in citizens' DigiLocker accounts",
  },
  {
    id: 12,
    api: "Legal Heir Certificate",
    link: "https://apisetu.gov.in/directory/api/edistrictkerala/edistrictkerala",
    details:
      "eDistrict Kerala (https://edistrict.kerala.gov.in/) is the online service delivery portal for Kerala State Govt. Certain documents issued by it (e.g. Residence, Income, Caste Certificates etc) are made available in citizens' DigiLocker accounts.",
  },
  {
    id: 13,
    api: "Life Certificate",
    link: "https://apisetu.gov.in/directory/api/edistrictkerala/edistrictkerala",
    details:
      "eDistrict Kerala (https://edistrict.kerala.gov.in/) is the online service delivery portal for Kerala State Govt. Certain documents issued by it (e.g. Residence, Income, Caste Certificates etc) are made available in citizens' DigiLocker accounts",
  },
  {
    id: 14,
    api: "Location Certificate",
    link: "https://apisetu.gov.in/directory/api/edistrictkerala/edistrictkerala",
    details:
      "eDistrict Kerala (https://edistrict.kerala.gov.in/) is the online service delivery portal for Kerala State Govt. Certain documents issued by it (e.g. Residence, Income, Caste Certificates etc) are made available in citizens' DigiLocker accounts.",
  },
  {
    id: 15,
    api: "Minority Certificate",
    link: "https://apisetu.gov.in/directory/api/edistrictkerala/edistrictkerala",
    details:
      "eDistrict Kerala (https://edistrict.kerala.gov.in/) is the online service delivery portal for Kerala State Govt. Certain documents issued by it (e.g. Residence, Income, Caste Certificates etc) are made available in citizens' DigiLocker accounts.",
  },
  {
    id: 16,
    api: "Nativity Certificate",
    link: "https://apisetu.gov.in/directory/api/edistrictkerala/edistrictkerala",
    details:
      "eDistrict Kerala (https://edistrict.kerala.gov.in/) is the online service delivery portal for Kerala State Govt. Certain documents issued by it (e.g. Residence, Income, Caste Certificates etc) are made available in citizens' DigiLocker accounts",
  },
  {
    id: 17,
    api: "One and the Same Certificate",
    link: "https://apisetu.gov.in/directory/api/edistrictkerala/edistrictkerala",
    details:
      "eDistrict Kerala (https://edistrict.kerala.gov.in/) is the online service delivery portal for Kerala State Govt. Certain documents issued by it (e.g. Residence, Income, Caste Certificates etc) are made available in citizens' DigiLocker accounts",
  },
  {
    id: 18,
    api: "Relationship Certificate",
    link: "https://apisetu.gov.in/directory/api/edistrictkerala/edistrictkerala",
    details:
      "eDistrict Kerala (https://edistrict.kerala.gov.in/) is the online service delivery portal for Kerala State Govt. Certain documents issued by it (e.g. Residence, Income, Caste Certificates etc) are made available in citizens' DigiLocker accounts",
  },
  {
    id: 19,
    api: "Residence Certificate",
    link: "https://apisetu.gov.in/directory/api/edistrictkerala/edistrictkerala",
    details:
      "eDistrict Kerala (https://edistrict.kerala.gov.in/) is the online service delivery portal for Kerala State Govt. Certain documents issued by it (e.g. Residence, Income, Caste Certificates etc) are made available in citizens' DigiLocker accounts",
  },
  {
    id: 20,
    api: "Class X School Leaving Certificate",
    link: "https://apisetu.gov.in/directory/api/pareekshabhavanker/pareekshabhavanker",
    details:
      "APIs provided by Kerala State Board of Public Examinations, Kerala.",
  },
  {
    id: 21,
    api: "School Leaving Certificate",
    link: "https://apisetu.gov.in/directory/api/pareekshabhavanker/pareekshabhavanker",
    details:
      "APIs provided by Kerala State Board of Public Examinations, Kerala.",
  },
  {
    id: 22,
    api: "Driving License",
    link: "https://apisetu.gov.in/directory/api/transportkl/transportkl",
    details:
      "Driving License (DL) and Vehicle Registration Certificate (RC) of the State, as available on Parivahan Sewa (http://parivahan.co.in/) of Ministry of Road Transport and Highways, are available on DigiLocker. Citizens can pull these documents into their DigiLocker accounts.",
  },
  {
    id: 23,
    api: "Registration of Vehicles",
    link: "https://apisetu.gov.in/directory/api/transportkl/transportkl",
    details:
      "Driving License (DL) and Vehicle Registration Certificate (RC) of the State, as available on Parivahan Sewa (http://parivahan.co.in/) of Ministry of Road Transport and Highways, are available on DigiLocker. Citizens can pull these documents into their DigiLocker accounts.",
  },
  {
    id: 24,
    api: "Degree/ Diploma Certificate - NIT Calicut",
    link: "https://apisetu.gov.in/directory/api/nitc/nitc",
    details:
      "National Institute of Technology Calicut is issuing their Digital awards for the following years, through DigiLocker. These can be pulled by Ph.D. students into their DigiLocker accounts. Degree - 2021 Marksheet - NA Diploma - NA Transcript - NA",
  },
  {
    id: 25,
    api: "Fitness Certificate",
    link: "https://apisetu.gov.in/directory/api/transport/transport",
    details:
      "Driving License (DL) & Vehicle Registration Certificate (RC) as available in Ministry of Transport's SARATHI & VAHAN portals (http://morth.nic.in/) can be pulled by citizens into their DigiLocker accounts.",
  },
  {
    id: 26,
    api: "Birth Certificate",
    link: "https://apisetu.gov.in/directory/api/rgi/rgi",
    details:
      "Birth and Death Records as issued by Registrar General of India (RGI) from August 2015 onward for following 20 States/UTs- Andaman & Nicobar Islands,Andhra Pradesh,Arunachal Pradesh,Assam Bihar,Chandigarh,Chhattisgarh,Dadra and Nagar Haveli and Daman Diu,Haryana,Himachal Pradesh,Jharkhand,Lakshadweep,Madhya Pradesh,Maharashtra,Mizoram,Nagaland,Sikkim,Tripura,Uttar Pradesh and Uttarakhand are available in DigiLocker",
  },
  {
    id: 27,
    api: "Death Certificate",
    link: "https://apisetu.gov.in/directory/api/rgi/rgi",
    details:
      "Birth and Death Records as issued by Registrar General of India (RGI) from August 2015 onward for following 20 States/UTs- Andaman & Nicobar Islands,Andhra Pradesh,Arunachal Pradesh,Assam Bihar,Chandigarh,Chhattisgarh,Dadra and Nagar Haveli and Daman Diu,Haryana,Himachal Pradesh,Jharkhand,Lakshadweep,Madhya Pradesh,Maharashtra,Mizoram,Nagaland,Sikkim,Tripura,Uttar Pradesh and Uttarakhand are available in DigiLocker",
  },
  {
    id: 28,
    api: "LPG Subscription Voucher",
    link: "https://apisetu.gov.in/directory/api/hindustanpetroleum/hindustanpetroleum",
    details:
      "eSubscription Voucher for LPG connections provided by HPCL (http://www.hindustanpetroleum.com/) are made available to citizens in their DigiLocker accounts.",
  },
  {
    id: 29,
    api: "Vehicle Insurance Certificate",
    link: "https://apisetu.gov.in/directory/api/transport/transport",
    details:
      "Driving License (DL) & Vehicle Registration Certificate (RC) as available in Ministry of Transport's SARATHI & VAHAN portals (http://morth.nic.in/) can be pulled by citizens into their DigiLocker accounts",
  },
  {
    id: 30,
    api: "Vehicle Tax Receipt",
    link: "https://apisetu.gov.in/directory/api/transport/transport",
    details:
      "Driving License (DL) & Vehicle Registration Certificate (RC) as available in Ministry of Transport's SARATHI & VAHAN portals (http://morth.nic.in/) can be pulled by citizens into their DigiLocker accounts",
  },
  {
    id: 31,
    api: "Insurance - Engineering",
    link: "https://apisetu.gov.in/directory/api/newindia/newindia",
    details:
      "General Insurance policies such as Motor, Health, Travel, Rural, Marine e.t.c issued by The New India Assurance Co. Ltd. are available to be pulled for citizens of India.",
  },
  {
    id: 32,
    api: "Insurance - Health",
    link: "https://apisetu.gov.in/directory/api/newindia/newindia",
    details:
      "General Insurance policies such as Motor, Health, Travel, Rural, Marine e.t.c issued by The New India Assurance Co. Ltd. are available to be pulled for citizens of India.",
  },
  {
    id: 33,
    api: "Freedom Fighter Certificate",
    link: "https://apisetu.gov.in/directory/api/eservices/eservices",
    details:
      "The Information Technology Development Agency (ITDA) has developed Apuni Sarkar Portal (https://eservices.uk.gov.in/) for Uttarakhand State. Certain documents issued by the department (eg. Caste, Income, Birth Certificate, etc) can be pulled into citizens' DigiLocker accounts.",
  },
];

export default APISetudata;
